<template>
<div class="control">
    <div class="select is-fullwidth">
        <select :required="config.required" :name="config.name ? config.name : config.label">
            <option :value="null">{{config.type == 'countrylist' ? 'Country' : '- select one -'}} {{config.required ? ' (*)' : ''}}</option>
            <option v-for="opt, key in config.options" :value="key">{{opt}}</option>
        </select>
    </div>
</div>
</template>

<script>
export default {
    name    :   'DropdownList',
    props   :   ['config']
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/formfields/DropdownList.vue